/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
/**  Used to pass react aria render props to the styling function and propagate them to the component */
const applyStylesWithRenderProps = <T>(fn: (state: T) => {
  className?: string;
  'data-style-src'?: string;
  style?: Readonly<Record<string, string | number>>;
}) => ({
  className: (state: T) => fn(state).className!,
  style: (state: T) => fn(state).style,
  'data-style-src': (state: T) => fn(state)['data-style-src'],
});

export { applyStylesWithRenderProps };
